import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAdmin, setIsAdmin] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const adminData = sessionStorage.getItem('admin');
    const adminLoggedIn = localStorage.getItem('adminLoggedIn');

    console.log('AdminLayout - Checking session:', { adminData: !!adminData, adminLoggedIn });

    if (!adminData && adminLoggedIn !== 'true') {
      console.log('No admin session, redirecting to login');
      navigate('/admin/login');
    } else {
      if (!adminData && adminLoggedIn === 'true') {
        sessionStorage.setItem(
          'admin',
          JSON.stringify({
            id: 1,
            email: 'admin@coinspire.com',
            role: 'super_admin',
          })
        );
      }
      setIsAdmin(true);
    }
    setChecking(false);
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.removeItem('admin');
    localStorage.removeItem('adminLoggedIn');
    navigate('/admin/login');
  };

  if (checking) {
    return (
      <div className="admin-shell admin-loading-shell">
        <div className="text-center">
          <div className="loading-spinner mx-auto mb-4"></div>
          <p className="text-gray-400 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return null;
  }

  const menuItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/admin/kyc-review', label: 'KYC Review', icon: '📋' },
    { path: '/admin/withdrawals', label: 'Withdrawals', icon: '💰' },
    { path: '/admin/trades', label: 'Enter Trade', icon: '📈' },
    { path: '/admin/signals', label: 'Trading Signals', icon: '📡' },
    { path: '/admin/users', label: 'Users', icon: '👥' },
  ];

  return (
    <div className="admin-shell">
      <header className="admin-topbar">
        <div className="admin-topbar-inner">
          <div>
            <h1 className="admin-brand">Coinspire Admin</h1>
            <p className="admin-subtext">Secure platform operations panel</p>
          </div>

          <button onClick={handleLogout} className="admin-logout-btn" type="button">
            Logout
          </button>
        </div>
      </header>

      <div className="admin-body">
        <aside className="admin-sidebar">
          <nav className="admin-nav">
            {menuItems.map((item) => (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`admin-nav-link ${location.pathname === item.path ? 'active' : ''}`}
                type="button"
              >
                <span className="admin-nav-icon">{item.icon}</span>
                <span>{item.label}</span>
              </button>
            ))}
          </nav>
        </aside>

        <main className="admin-main">
          <div className="admin-content-wrap">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;